import { hearingTemplateIncludes } from '../../constants/includes';
import { buildIncludesString } from '../../utilities/utilityFunctions';
import { BaseConnector } from './baseConnector';

class HearingTemplateConnector extends BaseConnector {
  static defaultIncludes = buildIncludesString(
    hearingTemplateIncludes.fields,
    hearingTemplateIncludes.fieldTemplates,
    hearingTemplateIncludes.fieldTypeSpecification,
    hearingTemplateIncludes.validationRules,
  );

  getHearingTemplates() {
    var url = `${this.baseApiUrl}/hearingTemplate?include=${HearingTemplateConnector.defaultIncludes}`;
    return this.authFetch(url);
  }
}

export { HearingTemplateConnector };
